export const INTEGRATIONS_DELETE_INTEGRATION = 'INTEGRATIONS_DELETE_INTEGRATION'
export const INTEGRATIONS_FETCH_ALL = 'INTEGRATIONS_FETCH_ALL'
export const INTEGRATIONS_FETCH_INTEGRATION_TYPES = 'INTEGRATIONS_FETCH_INTEGRATION_TYPES'
